import React from 'react'
import { useTrans } from 'hooks'
import { ClienteNode, PaginaNode } from '@gql/graphql'
import { GenericHero, Page, Prefooter, RivenditoreForm } from 'components/organisms'
import styles from './ContattaRivenditoreTemplate.module.sass'

interface Props {
  pagina?: PaginaNode
  rivenditore?: ClienteNode
}

const ContattaRivenditoreTemplate = (props: Props) => {
  const { pagina = undefined, rivenditore = undefined } = props

  const t = useTrans()

  return (
    <Page pagina={pagina} className={`${styles.root}`} recaptchaRequired={true}>
      <main>
        <GenericHero
          pagina={{
            ...pagina,
            descrizione: t('Il punto vendita che stai contattando è: <b>{0}</b>', [
              rivenditore
                ? `${rivenditore.nome} ${rivenditore.indirizzo}, ${rivenditore.cap} ${rivenditore.citta} ${rivenditore.provincia}`
                : '',
            ]),
          }}
        />
        <RivenditoreForm rivenditore={rivenditore} />
        <Prefooter skipRivenditore />
      </main>
    </Page>
  )
}

export default ContattaRivenditoreTemplate
